import { render } from "./icon-sign-contract.vue?vue&type=template&id=4bf4b42d"
const script = {}

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__